import type { StyledIconTone } from '@/components/ui/styled-icon'

export type AvailabilityChangeEffectKey =
  | 'store_closed'
  | 'pickup_delivery_unavailable'
  | 'pickup_paused'
  | 'delivery_paused'
  | 'designers_choice_only'
  | 'temporary_hours'
  | 'availability_change'

export interface AvailabilityChangePresentation {
  calendarClassName: string
  label: string
  legendIndicatorClassName: string
  tone: StyledIconTone
}

const availabilityChangePresentations: Record<
  AvailabilityChangeEffectKey,
  AvailabilityChangePresentation
> = {
  store_closed: {
    calendarClassName:
      'border-status-destructive-border/55 bg-status-destructive-background text-status-destructive-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Store closed',
    legendIndicatorClassName:
      'border border-status-destructive-border/55 bg-status-destructive-background',
    tone: 'destructive',
  },
  pickup_delivery_unavailable: {
    calendarClassName:
      'border-status-warning-border/55 bg-status-warning-background text-status-warning-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Pickup and delivery paused',
    legendIndicatorClassName: 'border border-status-warning-border/55 bg-status-warning-background',
    tone: 'warning',
  },
  pickup_paused: {
    calendarClassName:
      'border-status-warning-border/55 bg-status-warning-background text-status-warning-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Pickup pause',
    legendIndicatorClassName: 'border border-status-warning-border/55 bg-status-warning-background',
    tone: 'warning',
  },
  delivery_paused: {
    calendarClassName:
      'border-status-warning-border/55 bg-status-warning-background text-status-warning-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Delivery pause',
    legendIndicatorClassName: 'border border-status-warning-border/55 bg-status-warning-background',
    tone: 'warning',
  },
  designers_choice_only: {
    calendarClassName:
      'border-selection-border/35 bg-accentSecondary text-accentSecondary-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: "Designer's Choice only",
    legendIndicatorClassName: 'border border-selection-border/35 bg-accentSecondary',
    tone: 'brand',
  },
  temporary_hours: {
    calendarClassName:
      'border-status-info-border/55 bg-status-info-background text-status-info-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Temporary hours',
    legendIndicatorClassName: 'border border-status-info-border/55 bg-status-info-background',
    tone: 'info',
  },
  availability_change: {
    calendarClassName:
      'border-status-info-border/55 bg-status-info-background text-status-info-foreground transition-[border-color,box-shadow] hover:border-selection-border hover:shadow-md',
    label: 'Availability change',
    legendIndicatorClassName: 'border border-status-info-border/55 bg-status-info-background',
    tone: 'brand',
  },
}

export function getAvailabilityChangePresentation(
  effect: AvailabilityChangeEffectKey = 'availability_change'
): AvailabilityChangePresentation {
  return (
    availabilityChangePresentations[effect] ?? availabilityChangePresentations.availability_change
  )
}
